// @mui
import { Container, Grid } from '@mui/material';

import { Page } from '../../../components';

import { MaintenanceTabs } from '.';

// MaintenanceTabs owns the fetch for this record; this component used to
// dispatch the same action, so every detail view issued two identical requests.
// The two full-screen PDF dialogs that lived here were never opened by anything
// — the job card is now downloaded from MaintenanceDetailCard.
export default function MaintenanceDetail() {

  return (
    <>
      <Page title="Maintenance Detail">
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MaintenanceTabs />
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
